import { __awaiter } from "tslib";
/**
 * Download File from URL fetches the file contents from the given URL, and triggers a download of the file with the
 * specified filename.
 *
 * @param sourceUrl The URL to fetch the file from
 * @param filename  The name of the downloaded file
 */
export const downloadFileFromUrl = (sourceUrl, filename) => __awaiter(void 0, void 0, void 0, function* () {
    const blob = yield fetch(sourceUrl).then((r) => r.blob());
    downloadFileFromBlob(blob, filename);
});
/**
 * Download File from Blob triggers a download of the provided file blob with the specified filename.
 *
 * @param blob     The file blob to download
 * @param filename The name of the downloaded file
 */
export const downloadFileFromBlob = (blob, filename) => {
    var _a;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    (_a = link.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(link);
};
